export const ERROR_MESSAGE = {
  system: '系统开小差了，请稍后重试',
  network: '网络开小差了，请稍后重试',
  payment: '支付未完成',
  copy: '复制失败，请稍后重试',
  sku: '请选择规格',
  delete: '删除失败',
  memberLimit: '已达会员限购上限',
  regularOnSale: '商品暂未开售',
  checkAllLimitedInCart: '已达限购数量的商品自动取消勾选',
  checkOneLimitedInCart: '该商品已达限购数量',
  limitedCannotAddCart: '购物车添加数量已达限购上限',
  countDownCart: '定时开售商品不可以购买',
  modify: '修改失败',
  routeMp: '跳转小程序失败',
};

export const SUCCESS_MESSAGE = {
  payment: '支付成功',
  modify: '修改成功',
  copy: '复制成功',
  cart: '已加入购物车',
  delete: '删除成功',
  invalidCommodity: '已清除失效商品',
};

export const LOAD_MESSAGE = {
  payment: '正在提交支付',
};
